import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from './utils/utils';
import ResetPassword from "./components/Authentication/resetPassword";

export const PrivateRoute = ({ component: Component, auth, ...rest }) => {
    return (
        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => {
            if (!isLogin()) {
                // Store the full path including search params and hash
                const redirectPath = props.location.pathname + props.location.search + props.location.hash;
                localStorage.setItem('redirectPath', redirectPath);
                return <Redirect to={{
                    pathname: "/login",
                    state: { from: props.location }
                }} />;
            }
            
            return auth.user && auth.user.passwordReset ? 
                <Component {...props} auth={auth} /> :
                <ResetPassword {...props} auth={auth} />;
        }} />
    );
};

export const PublicRoute = ({ component: Component, auth, restricted, ...rest }) => {
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => (
            isLogin() && auth.user && auth.user.passwordReset && restricted ?
                <Redirect to={(auth.user.accessLevel === "Threat Analyst") ? "/clients" : (auth.user.accessLevel === "tprm-question-responder") ? "/risk-management-dashboard-vendor" : "/"} />
                : <Component {...props} auth={auth} />
        )} />
    );
};